import { Component, OnInit } from '@angular/core';
import { Helpers, ThemeService } from 'ngx-elvis-ds';
import { ConfigService } from 'src/app/config.service';
import { ModalController } from '@ionic/angular';
import { GUIService } from 'src/app/gui/gui.service';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.page.html',
  styleUrls: ['./welcome-dialog.page.scss'],
})
export class WelcomeDialogPage implements OnInit {

  pageMode: string;

  bgImgUrls: string[] = [
    Helpers.imageUrl('bg', 'bg00.jpg', this.configSvc),
    Helpers.imageUrl('bg', 'bg01.jpg', this.configSvc),
    Helpers.imageUrl('bg', 'bg02.jpg', this.configSvc),
    Helpers.imageUrl('bg', 'bg03.jpg', this.configSvc),
  ];

  vidUrls: any[] = [
    {
      video: Helpers.imageUrl('bg', 'vid00.webm', this.configSvc),
      poster: Helpers.imageUrl('bg', 'vid00poster.jpg', this.configSvc)
    }
  ];

  slidesOpts = {
    speed: 3000,
    autoplay: { delay: 12000 },
    effect: 'fade'
  };

  constructor(
    public themeSvc: ThemeService,
    public cartSvc: CartService,
    public guiSvc: GUIService,
    private configSvc: ConfigService,
    private modalCtrl: ModalController
  ) {
    if (this.configSvc.guiSettings.welcome && this.configSvc.guiSettings.welcome.mode) {
      this.pageMode = this.configSvc.guiSettings.welcome.mode;
    } else {
      this.pageMode = 'static';
    }
  }

  ngOnInit() {
  }

  onDismiss() {
    this.modalCtrl.dismiss();
  }

}
